import { useEffect, useRef, useState } from 'react';
import { isCharacterCounterReady, loadCharacterCounter } from './characterCount';

/**
 * Loads the grapheme counter and re-renders once loading settles, so counts switch from the fallback to graphemes.
 * Returns true once settled: loaded, or given up after the chunk retries (counts then stay on the regex fallback), so
 * callers waiting on it never stall. `onReady` runs once at that point: forms pass their
 * `validateForm` so an error computed while loading is redone.
 */
export const useCharacterCounter = (onReady?: () => void): boolean => {
  const [isSettled, setIsSettled] = useState(isCharacterCounterReady);
  const onReadyRef = useRef(onReady);
  onReadyRef.current = onReady;

  useEffect(() => {
    if (isSettled) return undefined;
    let isActive = true;
    loadCharacterCounter().then(() => {
      if (!isActive) return;
      setIsSettled(true);
      onReadyRef.current?.();
    });
    return () => {
      isActive = false;
    };
  }, [isSettled]);

  return isSettled;
};
